import React from 'react';
import { SvgIcon } from '../svg-icon';
const ArrowUp = ({ color, size, ...props }) => (React.createElement(SvgIcon, Object.assign({ color: color, viewBox: "0 0 24 24", width: size ? `${size}px` : '24px', height: size ? `${size}px` : '24px' }, props),
    React.createElement("path", { fill: "inherit", d: "M3.375 15.394c0-.173.066-.345.198-.477l6.795-6.795c.79-.79 2.074-.79 2.863 0l6.796 6.795a.675.675 0 1 1-.955.954l-6.795-6.794a.676.676 0 0 0-.955 0L4.527 15.87a.675.675 0 0 1-1.152-.477Z" })));
ArrowUp.displayName = 'ArrowUp'; // Fix for tsc
export default ArrowUp;
//# sourceMappingURL=ArrowUp.js.map